import React , {useEffect , useState , Fragment} from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import {Box , Divider } from "@mui/material";

//*Redux
import { useDispatch , useSelector} from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from "./CancelUnitsRequests.module.css";
import Datagrid from '../../../Subcomponents/Datagrid';
import ThreeDotsMenu from '../../../Subcomponents/ThreeDotsMenu';
import { getCancelUnitRequests, getProjectByProjectName } from '../../../Services/SustenanceService';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import SiteVisitIcon from "../../../Assets/Images/Common/noProjectFound.svg";

function CancelUnitsRequests() {
  const { projectId } = useParams();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [NoCancelRequestPresent , setNoCancelRequestPresent] = useState(null);
  const dispatch = useDispatch();

  const [CancelUnitData , setCancelUnitData] = useState([]);
  useEffect(() => {
    dispatch(action.activeMenu('cancelrequests'));
    getAllCancelUnitRequests(false);
  }, []);

  useEffect(() => {
    console.log("Project-Name" , projectId)
  }, [projectId])


  const CpColumns = [
    {
      field: 'LeadName',
      headerName: 'Lead Name',
      width: 220,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} style={{ overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}}>
            {params?.row?.allotmentPaymentId.leadId?.personId?.name? params?.row?.allotmentPaymentId?.leadId?.personId?.name :"-"}
          </Box>
        );
      },
    },
    {
      field: 'CPName',
      headerName: 'CP Name',
      width: 300,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} style={{ overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}}>
             {params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName ?
             params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName : "-"}

          </Box>
        );
      },
    },
    {
      field: 'SalesRepresentative',
      headerName: 'Sales Representative',
      width: 300,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} style={{ overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}}>
            {params?.row?.userId?.name ? params?.row?.userId?.name : "-"}
          </Box>
        );
      },
    },
    {
      field: 'Amount',
      headerName: 'Amount Paid',
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} >
             {params?.row?.allotmentPaymentId?.paidAmount}
          </Box>
        );
      },
    },
    {
      field: 'ProjectName',
      headerName: 'Project Name',
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} style={{ overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}}>
            {params?.row?.allotmentPaymentId?.unitId?.projectId?.projectName}
          </Box>
        );
      },
    },
    {
      field: 'CurrentUnitDetails',
      headerName: 'Current Unit Details',
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
             {/* {params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName ?params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName :"-"} -  */}
             {params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName ? params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName : params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName ?params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName :"-"}
             {params?.row?.allotmentPaymentId?.unitId?.unitNo ? params?.row?.allotmentPaymentId?.unitId?.unitNo : "-"}
            <Box m={1} component={'span'}> | </Box> 
            {params?.row?.allotmentPaymentId?.unitId?.inventoryTypeId?.type}
          </Box>
        );
      },
    },
    {
      field: 'CancelledUnitDetails',
      headerName: 'Cancelled Unit Details',
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
             {/* {params?.row?.allotmentPaymentId?.unitId} */}
             
            {/* {params.row.allotmentPaymentId} */}
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      renderCell: (params) => {
        return (
          <ThreeDotsMenu
            list={['Accept', 'Reject']}
            selectedValue={(e) => {
              console.log(e);
              // if (e === 'one') {
              //   navigate('/home/Sustenance/ConfigureEvent/Inventory');
              // }
            }}
          />
        );
      },
    },
  ];

  function getAllCancelUnitRequests(pageNumber,merge) {
    getCancelUnitRequests(projectId ,pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1).then((res) => {
      console.log("All-Cancel-Unit-Requests" , res)

      if(res.count > 0) {
        setNoCancelRequestPresent(true)
      } else {
        setNoCancelRequestPresent(false)
      }

      const Data = res.data.map((el,index) => ({
        ...el,
        id:el?.cancelUnitRequestId,
        index:index,
      }))

      if(merge) {
        setCancelUnitData((pre) => [...pre , ...Data])
      } else {
        setCancelUnitData([...Data])
      }
    }).catch((err) => {
      console.log("Cancel-Unit-Table-error" , err)
    })
  }
  
  function pageChanged(e){
    console.log(e)
    console.log("page---" , e);
    setPageMaintain(e)
    if (pageNumber < e) {
      setPageNumber(e);
    }
  }
  return (
    <Box className={cssClasses.Container}>
    <Box mb={2}>
      <Box className={cssClasses.HeaderTitle}>Cancel Unit Requests</Box>
      {/* <Box className={cssClasses.SubTitle}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </Box> */}
    </Box>

    <Divider />

    <Box className={cssClasses.SubHeaderTitle} margin={"2rem 0"}>Select Requests</Box>

    {NoCancelRequestPresent === true &&
    <Fragment>
    <Box margin={'2rem 0'}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.flexCol}>
            <Box className={cssClasses.SubTitle}>Filter by</Box>
            <Box width={'250px'}>
              <DropDown
                list={['All', 'ProjectA']}
                style={{
                  background: '#F2F4F7',
                  selectedColor: '#667085',
                }}
              />
            </Box>
          </Box>

          <Box className={cssClasses.flexCol}>
            <Box className={cssClasses.SubTitle} marginLeft={'2rem'}>
              Sort by
            </Box>
            <Box width={'250px'} margin={'0 2rem'}>
              <DropDown
                list={[
                  "Name A -> Z",
                  "Name Z -> A",
                  "latest first",
                  "oldest first",
                ]}
                style={{
                  background: '#FFFFFF',
                  selectedColor: '#667085',
                }}
              />
            </Box>
          </Box>

          <Box marginLeft={'auto'} marginTop={'2.5rem'}>
            <SearchBar placeholder={'Search by event name'} />
          </Box>
        </Box>
      </Box>
    <Box className={cssClasses.GridWrapper}>
        <Datagrid 
        rows={CancelUnitData} 
        columns={CpColumns} 
        hideFooter={false} 
        pageChanged={pageChanged}/>
      </Box>
    </Fragment>
    }

    {NoCancelRequestPresent === false &&
     <Box>
     <Box width={"100%"} height={"100%"}>
     <Box className={cssClasses.noDataMsg}>
     
     <Box className={cssClasses.emptyIcon}>
      <img src={SiteVisitIcon} alt="No Cancel Unit Requests  Yet" />
     </Box>
     <Box className={cssClasses.emptyTitle}>No Cancel Unit Requests were found</Box>
      </Box>
   </Box>
   </Box>
    }
    
   
  </Box>
  )
}

export default CancelUnitsRequests